import {
    PPD_CENSUS_DATA, PPD_CENSUS_SAVE,
    PPD_BUDGET, PPD_BUDGET_SAVE,
    PPD_ADMIN_SETTINGS, PPD_ADMIN_SETTINGS_GET,
    PPD_CONTRACT_HOURS, PPD_CONTRACT_HOURS_SAVE,
    COUNTERS, PPD_OVERVIEW
} from "../types";

const PPDReducer = (state = {}, action) => {
    if ([PPD_CENSUS_DATA, PPD_CENSUS_SAVE, PPD_OVERVIEW,
        PPD_BUDGET, PPD_BUDGET_SAVE, COUNTERS,
        PPD_ADMIN_SETTINGS, PPD_ADMIN_SETTINGS_GET,
        PPD_CONTRACT_HOURS, PPD_CONTRACT_HOURS_SAVE].includes(action.type)) {
        return { ...state, [action.type]: action.payload };
    };
    return state;
};

export default PPDReducer;
